import {
  SVButton,
  SVListFilters,
  SVListPagination,
  SVLoader,
} from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import StaffList from '@/components/staff/StaffList';
import { FILTERS } from '@/constants/filters';
import { ROUTES } from '@/constants/routes';
import useBuildListFilters from '@/hooks/requests/useBuildListFilters';
import { useGetStaffList } from '@/hooks/requests/useStaff';
import { Card, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function StaffListPage() {
  const navigate = useNavigate();
  const { staffList, isStaffListPending, totalRecordCount, isSuccess } =
    useGetStaffList();
  const { defaultValues, filters } = useBuildListFilters({
    enabled: isSuccess,
    extraFilters: [FILTERS.STATUS],
  });

  return (
    <DefaultLayout
      header={`Staff ${totalRecordCount ? `(${totalRecordCount})` : ''}`}
      buttons={[
        <SVButton
          onClick={() => navigate(ROUTES.STAFF_ADD)}
          fullWidth
          key="add"
          aria-label="Add Staff Member">
          Add
        </SVButton>,
      ]}>
      <SVListFilters
        defaultValues={defaultValues}
        filters={filters}
        searchLabel="Search by Email Address"
      />
      {isStaffListPending ? (
        <SVLoader />
      ) : (
        <>
          {staffList.length === 0 ? (
            <Card>
              <Typography>No results found</Typography>
            </Card>
          ) : (
            <Stack spacing={2}>
              <StaffList staffList={staffList} />
              <SVListPagination totalRecordCount={totalRecordCount} />
            </Stack>
          )}
        </>
      )}
    </DefaultLayout>
  );
}
